const currencies = [
  { uomId: 'AED', symbol: 'د.إ' },
  { uomId: 'AFN', symbol: '؋' },
  { uomId: 'AUD', symbol: '$' },
  { uomId: 'BDT', symbol: '৳' },
  { uomId: 'BGN', symbol: 'лв' },
  { uomId: 'BRL', symbol: 'R$' },
  { uomId: 'CAD', symbol: '$' },
  { uomId: 'CHF', symbol: 'CHF' },
  { uomId: 'CNY', symbol: '¥' },
  { uomId: 'CZK', symbol: 'Kč' },
  { uomId: 'DKK', symbol: 'kr' },
  { uomId: 'EUR', symbol: '€' },
  { uomId: 'GBP', symbol: '£' },
  { uomId: 'HKD', symbol: '$' },
  { uomId: 'HUF', symbol: 'Ft' },
  { uomId: 'IDR', symbol: 'Rp' },
  { uomId: 'ILS', symbol: '₪' },
  { uomId: 'INR', symbol: '₹' },
  { uomId: 'JPY', symbol: '¥' },
  { uomId: 'KRW', symbol: '₩' },
  { uomId: 'MXN', symbol: '$' },
  { uomId: 'MYR', symbol: 'RM' },
  { uomId: 'NOK', symbol: 'kr' },
  { uomId: 'NZD', symbol: '$' },
  { uomId: 'PHP', symbol: '₱' },
  { uomId: 'PKR', symbol: '₨' },
  { uomId: 'PLN', symbol: 'zł' },
  { uomId: 'RON', symbol: 'lei' },
  { uomId: 'RUB', symbol: '₽' },
  { uomId: 'SAR', symbol: '﷼' },
  { uomId: 'SEK', symbol: 'kr' },
  { uomId: 'SGD', symbol: '$' },
  { uomId: 'THB', symbol: '฿' },
  { uomId: 'TRY', symbol: '₺' },
  { uomId: 'USD', symbol: '$' },
  { uomId: 'ZAR', symbol: 'R' },
];

// Unknown currencies show their code (e.g. "ISK"), a missing one shows nothing.
// The trailing space keeps the symbol apart from the amount ("€ 120.00").
export function getCurrencySymbol(uomId) {
  if (!uomId) return '';
  const currency = currencies.find((c) => c.uomId === uomId.toUpperCase());
  return `${currency ? currency.symbol : uomId} `;
}

export function formatDate(isoString, format = 'YYYY-MM-DD HH:mm:ss') {
  const date = new Date(isoString);
  const replacements = {
    YYYY: date.getUTCFullYear(),
    MM: String(date.getUTCMonth() + 1).padStart(2, '0'),
    DD: String(date.getUTCDate()).padStart(2, '0'),
    HH: String(date.getUTCHours()).padStart(2, '0'),
    mm: String(date.getUTCMinutes()).padStart(2, '0'),
    ss: String(date.getUTCSeconds()).padStart(2, '0'),
    SSS: String(date.getUTCMilliseconds()).padStart(3, '0'),
  };

  let formatted = format;
  for (const token in replacements) {
    formatted = formatted.replace(new RegExp(token, 'g'), replacements[token]);
  }
  return formatted;
}
